import React from "react";
import PropTypes from "prop-types";
import { Tag } from "primereact/tag";

function Folders({ folders, onFolderClick }) {
  return (
    <div className="grid pr-2 pl-2 ">
      {folders?.map((folder) => {
        return (
          <div
            key={folder?.id}
            className={`field lg:col-3 md:col-3 sm:col-6 xs:col-12 p-0 pr-2 pointer`}
            onClick={() => onFolderClick(folder)}
          >
            <div className="folder-card-container ">
              <div className="cards-folder">
                <div className="icon-container">
                  <span className="pi pi-folder"></span>
                </div>
                <p className="cards-folder-heading">{folder.name}</p>
                {folder.isProcess && (
                  <Tag value="Processes" className="process-tag mt-2" />
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

Folders.propTypes = {
  folders: PropTypes.array.isRequired,
  onFolderClick: PropTypes.func,
};

export default Folders;
